/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function(){
        $(document).ready(function(){
          $(".lazy").lazyload({
            effect : "fadeIn"
          });
        });
        $(window).load(function(){
          var browserH = $(window).height();
          var browserW = $(window).width();
          var hash = window.location.hash;
          if(hash){
            setTimeout(function(){
              var thisPos = $(hash).offset();
              //console.log(thisPos.top);
              $('body, html').animate({'scrollTop' : thisPos.top});
            }, 500);
          }

          $(document).foundation();
          //$(document).on("scroll", onScroll);
          $('ul.subnav li a').click(function(e){
            e.preventDefault();
            var destination = $(this).attr('href');
            var pos = $(destination).offset();
            $('ul.subnav li a').removeClass('active');
            $(this).addClass('active');
            $('body, html').animate({'scrollTop' : pos.top-125}, 1000);
          });
          $('.btn_menu').click(function(){
            if($(this).hasClass('close')){
              $(this).removeClass('close');
              $('.hidden_nav').fadeOut();
              $('header').removeClass('openmenu');
            }else{
              $(this).addClass('close');
              $('.hidden_nav').fadeIn();
              $('header').addClass('openmenu');
            }
          });

          $('ul.mainnav li').hover(
            function(){
              //console.log('sub in');
              $(this).find('ul.sub-menu').fadeIn();
            }, function(){
              //console.log('sub out');
              $(this).find('ul.sub-menu').fadeOut();
            }
          );
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        $(window).load(function(){
          //callMultiscroll();
          var firstScroll = true;

          $('.btn_hsia').click(function(){
            $(this).fadeOut();
            $('.bkg_video').hide();
          });
          
          $('#multiscroll').fadeIn(function(){
            callMultiscroll();
            $('#multiscroll').animate({'opacity' : 1}, 800);
          });
          $('.home').css({'overflow' : 'visible'});
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'nobu': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        $(window).load(function(){
          $('ul.worldmapnav li').click(function(){
            var thisRel = $(this).attr('rel');
            $('ul.worldmapnav li').removeClass('active');
            $(this).addClass('active');
            if(thisRel === "restaurant"){
              $('.nobu_restaurant').fadeIn();
              $('.nobu_hotel, .nobu_animation').fadeOut();
            }else if(thisRel === "hotel"){
              $('.nobu_restaurant, .nobu_animation').fadeOut();
              $('.nobu_hotel').fadeIn();
            }else{
              $('.nobu_restaurant, .nobu_hotel').fadeOut();
              $('.nobu_animation').fadeIn();
            }
          });
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'neighborhood': {
      init: function() {
        // JavaScript to be fired on the about us page
      },finalize: function() {
        $(window).load(function(){
          $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();
            if(scroll > 135){
              $('header').stop().animate({'background-color' : 'rgba(0,0,0,0.7)'});
            }else{
              $('header').stop().animate({'background-color' : 'rgba(0,0,0,0)'});
            }
          });
          $('.btn_map').click(function(e){
            e.preventDefault();
            var thisPos = $('#map').offset();
            $('html, body').animate({'scrollTop' : thisPos.top}, 1200);
          });
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'team': {
      init: function(){
        // JavaScript to be fired on the about us page
      },finalize: function(){
        $(window).load(function(){
          var browserW = $(window).width();
          if(browserW >= 1024){
            $("#sushibox").stick_in_parent();
          }
        });
        $(window).resize(function(){
          var browserW = $(window).width();
          if(browserW >= 1024){
            $("#sushibox").stick_in_parent();
          }else{
            $("#sushibox").trigger("sticky_kit:detach");
          }
          
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'building': {
      init: function(){
        // JavaScript to be fired on the about us page
      },finalize: function(){
        $(window).load(function(){
          $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();
            if(scroll > 135){
              $('header').stop().animate({'background-color' : 'rgba(0,0,0,0.7)'});
            }else{
              $('header').stop().animate({'background-color' : 'rgba(0,0,0,0)'});
            }
          });
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  function callMultiscroll(){
    $('#multiscroll').multiscroll({
      sectionsColor: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
      anchors: [],
      navigation: true,
      navigationPosition: 'right',
      navigationColor: '#ffffff',
      navigationTooltips: ['NOBU', 'BUILDING', 'RESIDENCES', 'AMENITIES', 'NEIGHBORHOOD', 'FLOORPLANS', 'VIDEOS', 'PRESS', 'TEAM', 'CONTACT'],
      menu: '#menu',
      paddingTop: '125px',
      paddingBottom: '40px',
      css3: true,
      responsiveWidth: 1023,
      responsiveExpand: true,
      //responsiveExpandKey: 'aWZzdHVkaW9ueS5jb21fWVdVY21WemNHOXVjMmwyWlVWNGNHRnVaQT09WVdu'
      responsiveExpandKey: 'bm9idXJlc2lkZW5jZXMuY2FfVzR0Y21WemNHOXVjMmwyWlVWNGNHRnVaQT09R1E3'
    });

    $('*').filter(function() {
      return $(this).css("z-index") === '9999999';
    });
  }

  function onScroll(event){
    var scrollPos = $(document).scrollTop();

    $('.multiscroll-tooltip').removeClass('show');

    $('ul.subnav li a').each(function () {
        var currLink = $(this);
        var currLi = $(this).parent('li');
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top-125 <= scrollPos && refElement.position().top-125 + refElement.height() > scrollPos) {
          $('ul.subnav li a').removeClass("active");
          currLink.addClass("active");
          currLi.addClass("active");
        }
        else{
          currLink.removeClass("active");
          currLi.removeClass("active");
        }
    });
  }

})(jQuery); // Fully reference jQuery after this point.
